export default {
    copy(obj) { 
        return JSON.parse(JSON.stringify(obj));
    },
}